import React from "react";
import Table from "react-bootstrap/Table";
import { Container, Row, Col } from "react-bootstrap";
import check_german_exitence from "./GermanCell";
import GermanCell from "./GermanCell";
import RomanizationFormatter from "../romanization-formater";
import { defaultFontSize } from "../../common/style-consts";

interface RowCountOneTableProps {
  data: any;
}

const RowCountOneTable: React.FC<RowCountOneTableProps> = ({ data }) => {
  // the below code is duplicated!
  const processGermanItems = (item: any) => {
    const germanWords = item.german.split('\n').map((word: string) => word.trim());

    if (germanWords.length > 1) {
      // If there are multiple German words, duplicate the item
      const duplicatedItems = germanWords.map((word: string, index: number) => ({
        ...item,
        id: item.id * 1000 + index, // Adjust the ID to make it unique
        german: word
      }));

      // Return the duplicated items
      return duplicatedItems;
    }

    // If there is only one German word, return the original item
    return [item];
};


  // Process the data to include duplicated items
  const processedData = data.flatMap(processGermanItems);

    // Function to copy URL to clipboard
  const handleRowClick = () => {
    const currentUrl = window.location.href; // Get the current URL
    navigator.clipboard.writeText(currentUrl).then(() => {
      alert("URL copied to clipboard!");
    }).catch((err) => {
      console.error("Failed to copy: ", err);
    });
  };


  return (
    <>
      <Row style={{ width: "95%", justifyContent: "center" }}>
        <Col className="gy-3">
          <Table responsive striped bordered hover variant="dark" style={{fontSize:defaultFontSize}}>
            <tbody>
              {processedData.map((item: any) => {
                  console.log("This is hatem: ", item)
                  return (
                    <tr key={item.id} onClick={handleRowClick}>
                      <td>
                        <GermanCell item={item} />
                      </td>
                      <td style={{ direction: "rtl" }}>
                        {item.arabic + " - "}
                        <RomanizationFormatter
                          inputString={item.arabic_romanization}
                        />
                      </td>
                    </tr>
                  )
                }
                )}
              <tr onClick={handleRowClick}>
                <td>Bestimmte Form</td>
                <td style={{ direction: "rtl" }}>
                  {data[0].arabic2 + " - "}
                  <RomanizationFormatter
                    inputString={data[0].arabic2_romanization}
                  />
                </td>
              </tr>
              <tr onClick={handleRowClick}>
                <td>Morphemtyp</td>
                <td style={{ direction: "rtl" }}>
                  <RomanizationFormatter
                    inputString={data[0].morpheme.romanization}
                  />
                  {" - " + data[0].morpheme.arabic}
                </td>
              </tr>
              <tr onClick={handleRowClick}>
                <td>Wurzel</td>
                <td style={{ direction: "rtl" }}>
                  {data[0].root.root + " - "}
                  <RomanizationFormatter
                    inputString={data[0].root.romanization}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
          {/* Make use of the 'data' prop as needed */}
        </Col>
      </Row>
    </>
  );
};

export default RowCountOneTable;
